import type { EntityTypeMap, ValidationResult } from 'types';

export const validatePerformanceEntity = (entity: EntityTypeMap['assetType']): ValidationResult => {
    if (!entity.name) {
        return {
            status: 'error',
            errorMessage: 'Name is required',
        };
    }
    return {
        status: 'success',
    };
};
